
import React from "react";
import ContentLoader from "react-content-loader";

const LabCardSkeleton = (props) => (
  <ContentLoader
    speed={2}
    width="100%"
    height={160}
    viewBox="0 0 1000 160"
    backgroundColor="#e0e0e0"
    foregroundColor="#cfcfcf"
    {...props}
    style={{
      marginBottom: "24px",
      marginLeft: "0px",       
      marginRight: "0px",
      overflow: "hidden",
      boxSizing: "border-box",
    }}
  >
   
    <rect x="0" y="30" rx="6" ry="6" width="100" height="100" />

    <rect x="120" y="30" rx="4" ry="4" width="500" height="20" />

    <rect x="120" y="60" rx="3" ry="3" width="700" height="14" />
    <rect x="120" y="80" rx="3" ry="3" width="680" height="14" />

    <rect x="120" y="110" rx="3" ry="3" width="300" height="14" />
  </ContentLoader>
);

const ShimmerLearningLab = () => {
  return (
    <div
      style={{
        padding: "1rem 24px",     
        overflowX: "hidden",      
      }}
    >
      <LabCardSkeleton />
      <LabCardSkeleton />
      <LabCardSkeleton />
      <LabCardSkeleton />
    </div>
  );
};

export default ShimmerLearningLab;
